import React from 'react'
import Navbar from '../components/Navbar'
import InnerLeadBanner from '../components/InnerLeadBanner'
import WhatWeAreDoing from '../components/WhatWeAreDoing'

const CommunityVenturePortfolio = () => {
  return (
    <>
    <Navbar />
    <InnerLeadBanner title={'Community Venture Portfolio (CVP)'}/>
    <WhatWeAreDoing />
    {/* <div>CommunityVenturePortfolio</div> */}
    </>
    
  )
}

export default CommunityVenturePortfolio